module.exports = __webpack_public_path__ + "img/farzana-christopher-78.1cd1be87.jpg";